export default [
  {
    path: '/apps/calendar',
    name: 'apps-calendar',
    component: () => import('@/views/apps/calendar/Calendar.vue'),
    meta: {
      resource: 'Calendar',
      action: 'read',
    },
  },
  // *===============================================---*
  // *--------- MEALS -------------------------------*
  // *===============================================---*
  {
    path: '/apps/mealplan',
    name: 'apps-mealplan-patient',
    component: () => import('@/views/apps/mealplan/Calendar.vue'),
    meta: {
      resource: 'MealPlanPatient',
      action: 'read',
    },
  },
  {
    path: '/apps/:id/mealplan',
    name: 'apps-mealplan-practitioner',
    component: () => import('@/views/apps/mealplan/Calendar.vue'),
    meta: {
      resource: 'MealPlanPractitioner',
      action: 'read',
    },
  },
  {
    path: '/apps/:id/mealplan/:idmeal/mealinfo/:istemplate',
    name: 'apps-mealinfo-practitioner',
    component: () => import('@/views/apps/mealinfo/MealInfo.vue'),
    meta: {
      resource: 'MealInfoPractitioner',
      action: 'read',
    },
  },
  {
    path: '/apps/mealplan/:idmeal/mealinfo/:istemplate',
    name: 'apps-mealinfo-patient',
    component: () => import('@/views/apps/mealinfo/MealInfo.vue'),
    meta: {
      resource: 'MealInfoPatient',
      action: 'read',
    },
  },
  // *===============================================---*
  // *--------- TODO ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/todo',
    name: 'apps-todo',
    component: () => import('@/views/apps/todo/Todo.vue'),
    meta: {
      resource: 'Todo',
      action: 'read',
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
    },
  },
  {
    path: '/app/apps/:id/todo/',
    name: 'apps-todo-user',
    component: () => import('@/views/apps/todo/Todo.vue'),
    meta: {
      resource: 'TodoID',
      action: 'read',
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
    },
  },

  // *===============================================---*
  // *--------- NOTE ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/note',
    name: 'apps-note',
    component: () => import('@/views/apps/note/Note.vue'),
    meta: {
      resource: 'Note',
      action: 'read',
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
    },
  },
  {
    path: '/apps/:id/note',
    name: 'apps-note-user',
    component: () => import('@/views/apps/note/Note.vue'),
    meta: {
      resource: 'NoteID',
      action: 'read',
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
    },
  },
  {
    path: '/apps/:id/note/:idnote/anamnesis',
    name: 'apps-note-anamnesis',
    component: () => import('@/views/apps/anamnesis/Anamnesis.vue'),
    meta: {
      resource: 'Anamnesis',
      action: 'read',
      contentClass: 'todo-application',
    },
  },
  // *===============================================---*
  // *--------- Card ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/card',
    name: 'apps-card',
    component: () => {
      const importWithRetry = (retries = 3, delay = 1000) =>
        new Promise((resolve, reject) => {
          function attempt() {
            import('@/views/apps/card/Card.vue')
              .then(resolve)
              .catch(error => {
                if (error.name === 'ChunkLoadError' && retries > 0) {
                  retries--;
                  setTimeout(attempt, delay);
                } else {
                  reject(error);
                }
              });
          }
          attempt();
        });

      return importWithRetry();
    },
    meta: {
      resource: 'Card',
      action: 'read',
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
    },
  },
  {
    path: '/apps/:id/card',
    name: 'apps-card-user',
    component: () => import('@/views/apps/card/Card.vue'),
    meta: {
      resource: 'CardID',
      action: 'read',
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
    },
  },
  {
    path: '/apps/card/:idcard/draggable',
    name: 'apps-card-draggable',
    component: () => import('@/views/apps/carddraggable/CardDraggable.vue'),
    meta: {
      resource: 'CardDraggable',
      action: 'read',
      contentClass: 'todo-application',
    },
  },

  // *===============================================---*
  // *--------- SHOPPING LIST ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/:id/shoppinglist',
    name: 'apps-shoppinglist-practitioner',
    component: () => import('@/views/apps/shoppinglist/ShoppingList.vue'),
    meta: {
      resource: 'ShoppingListPractitioner',
      action: 'read',
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
    },
  },
  {
    path: '/apps/shoppinglist',
    name: 'apps-shoppinglist-patient',
    component: () => import('@/views/apps/shoppinglist/ShoppingList.vue'),
    meta: {
      resource: 'ShoppingListPatient',
      action: 'read',
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
    },
  },

  // *===============================================---*
  // *--------- CHAT  ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/chat',
    name: 'apps-chat',
    component: () => import('@/views/apps/chat/Chat.vue'),
    meta: {
      resource: 'Chat',
      action: 'read',
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
    },
  },

  // *===============================================---*
  // *--------- ECOMMERCE  ---------------------------------------*
  // *===============================================---*
  /*{
    path: '/apps/e-commerce/shop',
    name: 'apps-e-commerce-shop',
    component: () => import('@/views/apps/e-commerce/e-commerce-shop/ECommerceShop.vue'),
    meta: {
      contentRenderer: 'sidebar-left-detached',
      contentClass: 'ecommerce-application',
      pageTitle: 'Shop',
      breadcrumb: [
        {
          text: 'ECommerce',
        },
        {
          text: 'Shop',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/e-commerce/wishlist',
    name: 'apps-e-commerce-wishlist',
    component: () => import('@/views/apps/e-commerce/e-commerce-wishlist/ECommerceWishlist.vue'),
    meta: {
      pageTitle: 'Wishlist',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'ECommerce',
        },
        {
          text: 'Wishlist',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/e-commerce/checkout',
    name: 'apps-e-commerce-checkout',
    component: () => import('@/views/apps/e-commerce/e-commerce-checkout/ECommerceCheckout.vue'),
    meta: {
      pageTitle: 'Checkout',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'ECommerce',
        },
        {
          text: 'Checkout',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/e-commerce/:slug',
    name: 'apps-e-commerce-product-details',
    component: () => import('@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue'),
    meta: {
      pageTitle: 'Product Details',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'ECommerce',
        },
        {
          text: 'Shop',
          active: true,
        },
        {
          text: 'Product Details',
          active: true,
        },
      ],
    },
  },*/

  // *===============================================---*
  // *--------- USER ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/users/list',
    name: 'apps-users-list',
    component: () => import('@/views/apps/user/users-list/UsersList.vue'),
    meta: {
      resource: 'UsersList',
      action: 'read',
    },
  },
  {
    path: '/apps/users/view/:id',
    name: 'apps-users-view',
    component: () => import('@/views/apps/user/users-view/UsersView.vue'),
    meta: {
      resource: 'UsersView',
      action: 'read',
    },
  },
  {
    path: '/apps/users/edit/:id',
    name: 'apps-users-edit',
    component: () => import('@/views/apps/user/users-edit/UsersEdit.vue'),
    meta: {
      resource: 'UsersEdit',
      action: 'read',
    },
  },

  // Invoice
  {
    path: '/apps/invoice/list',
    name: 'apps-invoice-list',
    component: () => import('@/views/apps/invoice/invoice-list/InvoiceList.vue'),
    meta: {
      resource: 'Invoice',
      action: 'read',
    },
  },
  /*{
    path: '/apps/invoice/preview/:id',
    name: 'apps-invoice-preview',
    component: () => import('@/views/apps/invoice/invoice-preview/InvoicePreview.vue'),
  },*/
  /*{
    path: '/apps/invoice/add/',
    name: 'apps-invoice-add',
    component: () => import('@/views/apps/invoice/invoice-add/InvoiceAdd.vue'),
  },*/
  /*{
    path: '/apps/invoice/edit/:id',
    name: 'apps-invoice-edit',
    component: () => import('@/views/apps/invoice/invoice-edit/InvoiceEdit.vue'),
  },*/
]
